import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { useAppSelector, useAppDispatch } from "../../_App/Redux/hooks";
import {
  deleteWeekends,
  ListPublicHolidaysAndWeekends,
  savePublicHolidayOrWeekend,
} from "../../_App/Redux/Slices/holidays/holidaysSlice";
import HolidayForm from "./NewHolidayModal";
import LOader from "../../_Layouts/LOader";
import _ from "lodash";

interface YearCalendarProps {
  refresh: boolean;
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
}

const YearCalendar: React.FC<YearCalendarProps> = ({ refresh, setRefresh }) => {
  const events = useAppSelector(ListPublicHolidaysAndWeekends);
  const [weekendDays, setWeekendDays] = useState<string[]>([]);
  useEffect(() => {
    if (events && events.length) {
      const weekendEvents = events.filter((event) => event.type === "weekend");
      console.log(events);
      const groupedByDay = _.groupBy(weekendEvents, "day");
      console.log(groupedByDay);
      // Output the result
      setWeekendDays(Object.keys(groupedByDay));
    }
  }, [events, refresh]);

  const dispatch = useAppDispatch();
  const year = 2025;

  const [showModal, setShowModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [selectedEvent, setSelectedEvent] = useState<any>(null);
  const [weekendDay, setWeekendDay] = useState<string>("dimanche");

  const handleDayClick = (date: Date) => {
    setSelectedDate(date);
    const event = events.find(
      (e) => new Date(e.date).toDateString() === date.toDateString()
    );
    setSelectedEvent(event || null);
    setShowModal(true);
  };

  const getTileContent = ({ date, view }: { date: Date; view: string }) => {
    if (view === "month") {
      const event = events.find(
        (e) => new Date(e.date).toDateString() === date.toDateString()
      );
      if (event) {
        return (
          <div
            className="bg-green-300 rounded-full w-6 h-6 flex items-center justify-center text-white text-xs"
            style={{
              backgroundColor: event.type === "weekend" ? "red" : "green",
              width: "100%",
              height: "100%",
            }}
          ></div>
        );
      }
    }
    return null;
  };
  const [loading, setLoading] = useState(false);

  const deleteAllWeekends = async () => {
    const res = await dispatch(deleteWeekends(weekendDay));
    setWeekendDays([]);
    setRefresh(!refresh);
  };

  const insertWeekends = async (day: string) => {
    const dayIndex = [
      "dimanche",
      "lundi",
      "mardi",
      "mercredi",
      "jeudi",
      "vendredi",
      "samedi",
    ].indexOf(day);

    setLoading(true);

    const holidays = [];

    for (let month = 0; month < 12; month++) {
      for (let date = 1; date <= 31; date++) {
        const currentDate = new Date(year, month, date);

        if (
          currentDate.getMonth() === month &&
          currentDate.getDay() === dayIndex
        ) {
          holidays.push({
            date: currentDate.toLocaleDateString("en-CA"),
            type: "weekend",
            recurring: 0,
            day: weekendDay,
          });
        }
      }
    }

    if (holidays.length > 0) {
      await dispatch(savePublicHolidayOrWeekend(holidays));
    }

    setLoading(false);
    setRefresh(!refresh);
  };

  return loading ? (
    <LOader />
  ) : (
    <div className="content-page">
      {" "}
      <div className="row">
        {" "}
        <div className="col-4">
          {" "}
          <label className="mr-2 font-semibold">
            Selectionner le jour de weekend de votre region{" "}
          </label>
        </div>
        <div className="col-4">
          <select
            value={weekendDay}
            onChange={(e) => setWeekendDay(e.target.value)}
            className="border p-2 rounded"
          >
            {[
              "dimanche",
              "lundi",
              "mardi",
              "mercredi",
              "jeudi",
              "vendredi",
              "samedi",
            ].map((day) => (
              <option key={day} value={day}>
                {day}
              </option>
            ))}
          </select>
        </div>{" "}
        <div className="col-4">
          {weekendDays && weekendDays.includes(weekendDay) ? (
            <button
              onClick={() => deleteAllWeekends()}
              className="btn btn-danger ml-4 px-4 py-2 bg-blue-500 text-white rounded"
            >
              Supprimer les weekends : {weekendDay}
            </button>
          ) : (
            <button
              onClick={() => insertWeekends(weekendDay)}
              className="btn btn-info ml-4 px-4 py-2 bg-blue-500 text-white rounded"
            >
              Appliquer
            </button>
          )}
        </div>
      </div>{" "}
      <div
        className="p-4 grid grid-cols-3 gap-6 mt-5"
        style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}
      >
        <div className="row">
          {Array.from({ length: 12 }).map((_, monthIndex) => (
            <div
              key={monthIndex}
              className="border rounded-lg shadow-sm bg-white flex flex-col items-center m-2"
            >
              <h2
                className="text-center font-semibold mb-4 text-lg"
                style={{ textTransform: "capitalize" }}
              >
                {new Date(year, monthIndex).toLocaleString("fr-FR", {
                  month: "long",
                })}
              </h2>

              <Calendar
                view="month"
                tileContent={getTileContent}
                showNeighboringMonth={false}
                defaultActiveStartDate={new Date(year, monthIndex, 1)}
                onClickDay={handleDayClick}
                className="w-full"
                locale="fr-FR"
                nextLabel={null} // Removes the next arrow
                prevLabel={null} // Removes the previous arrow
              />
            </div>
          ))}
        </div>

        <HolidayForm
          showModal={showModal}
          setShowModal={setShowModal}
          date={selectedDate}
          setRefresh={setRefresh}
          refresh={refresh}
          selectedEvent={selectedEvent}
          setSelectedEvent={setSelectedEvent}
        />
      </div>
    </div>
  );
};

export default YearCalendar;
